import { render, staticRenderFns } from "./adminLayout.vue?vue&type=template&id=5c902120&scoped=true&"
import script from "./adminLayout.vue?vue&type=script&lang=ts&"
export * from "./adminLayout.vue?vue&type=script&lang=ts&"
import style0 from "./adminLayout.vue?vue&type=style&index=0&id=5c902120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c902120",
  null
  
)

export default component.exports